import { render, staticRenderFns } from "./programs.vue?vue&type=template&id=4a51db17"
import script from "./programs.vue?vue&type=script&lang=js"
export * from "./programs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLoaderPage: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/LoaderPage/LoaderPage.vue').default,HotPrograms: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Programs/Programs.vue').default})
